import React from 'react';
import { motion } from 'framer-motion';
import './SignInLeftVisual.css';

function SignInLeftVisual() {
  return (
    <div className="signin-left-visual">
      <motion.h1
        className="signin-brand-title"
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
      >
        Back to clear thinking
      </motion.h1>
      <motion.p
        className="signin-tagline"
        initial={{ opacity: 0, y: -10 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6, delay: 0.2, ease: [0.22, 1, 0.36, 1] }}
      >
        Back to meaningful progress
      </motion.p>
      <div className="signin-visual-container">
        <motion.div
          className="signin-node signin-node-1"
          initial={{ opacity: 0, scale: 0 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.5, delay: 0.4 }}
        />
        <motion.div
          className="signin-node signin-node-2"
          initial={{ opacity: 0, scale: 0 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.5, delay: 0.5 }}
        />
        <motion.div
          className="signin-node signin-node-3"
          initial={{ opacity: 0, scale: 0 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.5, delay: 0.6 }}
        />
        <motion.svg
          className="signin-connections"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.8, delay: 0.7 }}
        >
          <motion.line
            x1="50%"
            y1="30%"
            x2="30%"
            y2="50%"
            stroke="var(--accent-mint)"
            strokeWidth="2"
            strokeDasharray="5,5"
            initial={{ pathLength: 0 }}
            animate={{ pathLength: 1 }}
            transition={{ duration: 1, delay: 0.8 }}
          />
          <motion.line
            x1="50%"
            y1="30%"
            x2="70%"
            y2="50%"
            stroke="var(--accent-mint)"
            strokeWidth="2"
            strokeDasharray="5,5"
            initial={{ pathLength: 0 }}
            animate={{ pathLength: 1 }}
            transition={{ duration: 1, delay: 0.9 }}
          />
        </motion.svg>
      </div>
    </div>
  );
}

export default SignInLeftVisual;
